import { useEffect, useState } from 'react';

import { styled } from '@mui/material/styles';
import { LoadScript } from '@react-google-maps/api';

import { AddLocationFormV2 } from './AddLocationFormV2';

import { isV2PermissionsEnabled } from '../../../helpers/featureFlags/isV2PermissionsEnabled';
import { useProviderRbac } from '../../../hooks/useProviderRbac';
import { loadState } from '../../../store/ProviderLocationsContext';

const googleApiLibs = ['places'];

export const AddLocationsV2 = ({ closeDrawer, onSuccess, onRefreshTransactions }) => {
  const [initialState, setInitialState] = useState({});
  const teamType = JSON.parse(sessionStorage.getItem('TEAM_TYPE'));
  const providerInfoObj = JSON.parse(sessionStorage.getItem('USER_DATA'));
  const { providerNameRbac } = useProviderRbac();

  const providerName = isV2PermissionsEnabled()
    ? providerNameRbac
    : teamType === 'Provider'
    ? providerInfoObj['Team Name']
    : '';

  useEffect(() => {
    const storedState = loadState();

    setInitialState(storedState);
  }, []);

  return (
    <Container>
      <LoadScript
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY_RESTRICT}
        libraries={googleApiLibs}
      >
        {initialState?.majorProvidersList?.length > 0 && (
          <AddLocationFormV2
            providerName={providerName}
            userType={teamType}
            majorProvidersList={initialState.majorProvidersList}
            onClose={closeDrawer}
            onSuccessAddtion={onSuccess}
            onRefreshTransactions={onRefreshTransactions}
          />
        )}
      </LoadScript>
    </Container>
  );
};

const Container = styled('div')(({ theme }) => ({
  maxWidth: '40vw',
  width: '800px',
}));
